import { html } from 'rune-ts';

export const CloseIcon = html`
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none">
    <g clip-path="url(#clip0_132_1042)">
      <path
        d="M13.2583 12.0001L20.7379 4.51006C21.0874 4.16006 21.0874 3.60006 20.7379 3.26006C20.3884 2.91006 19.8291 2.91006 19.4796 3.26006L12 10.7401L4.52039 3.26006C4.17087 2.91006 3.61165 2.91006 3.26214 3.26006C2.91262 3.61006 2.91262 4.17006 3.26214 4.51006L10.7417 12.0001L3.26214 19.4901C2.91262 19.8401 2.91262 20.4001 3.26214 20.7401C3.4319 20.9101 3.66158 21.0001 3.89126 21.0001C4.12094 21.0001 4.34064 20.9101 4.52039 20.7401L12 13.2601L19.4796 20.7401C19.6494 20.9101 19.8791 21.0001 20.1087 21.0001C20.3384 21.0001 20.5581 20.9101 20.7379 20.7401C21.0874 20.3901 21.0874 19.8301 20.7379 19.4901L13.2583 12.0001Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_1042">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const ImportantIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 20" fill="none">
    <g clip-path="url(#clip0_6030_18975)">
      <path
        d="M9.99935 1.6665C5.39935 1.6665 1.66602 5.39984 1.66602 9.99984C1.66602 14.5998 5.39935 18.3332 9.99935 18.3332C14.5993 18.3332 18.3327 14.5998 18.3327 9.99984C18.3327 5.39984 14.5993 1.6665 9.99935 1.6665ZM11.041 14.0665C11.041 14.6415 10.5743 15.1082 9.99935 15.1082C9.42435 15.1082 8.95768 14.6415 8.95768 14.0665V9.6915C8.95768 9.1165 9.42435 8.64984 9.99935 8.64984C10.5743 8.64984 11.041 9.1165 11.041 9.6915V14.0665ZM9.99935 6.98317C9.42435 6.98317 8.95768 6.5165 8.95768 5.9415C8.95768 5.3665 9.42435 4.89984 9.99935 4.89984C10.5743 4.89984 11.041 5.3665 11.041 5.9415C11.041 6.5165 10.5743 6.98317 9.99935 6.98317Z"
        fill="#6B6B6B"
      />
    </g>
    <defs>
      <clipPath id="clip0_6030_18975">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const MarkIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
    <circle cx="2" cy="2" r="2" fill="#1C75FF" />
  </svg>
`;

export const ListMarkIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="2" height="2" viewBox="0 0 2 2" fill="none">
    <circle cx="1" cy="1" r="1" fill="#6B6B6B" />
  </svg>
`;

export const FormRowAsteriskIcon = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="4"
  height="4"
  viewBox="0 0 4 4"
  fill="none"
>
  <circle cx="2" cy="2" r="2" fill="#1C75FF" />
</svg>`;

export const DropDownIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M2 4L6 8L10 4" stroke="#141414" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
`;

export const StudioDropDownIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M7.4301 11.6671C7.74672 12.1424 8.44506 12.1424 8.76168 11.6671L13.041 5.24337C13.3952 4.71171 13.014 3.99984 12.3752 3.99984H3.81659C3.17776 3.99984 2.79662 4.71171 3.1508 5.24337L7.4301 11.6671Z"
      fill="#141414"
    />
  </svg>
`;

export const DatePickerCalendarIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    <g clip-path="url(#clip0_7994_61407)">
      <path
        d="M17.5833 3.54154H15.1083V2.39154C15.1083 1.99154 14.7833 1.6582 14.3749 1.6582C13.9666 1.6582 13.6416 1.9832 13.6416 2.39154V3.54154H7.33327V2.39154C7.33327 1.99154 7.00827 1.6582 6.59994 1.6582C6.1916 1.6582 5.8666 1.9832 5.8666 2.39154V3.54154H3.3916C2.69993 3.54154 2.1416 4.09987 2.1416 4.79154V17.1499C2.1416 17.8082 2.69993 18.3332 3.3916 18.3332H17.5583C18.2499 18.3332 18.8083 17.7999 18.8083 17.1499V4.79154C18.8083 4.09987 18.2499 3.54154 17.5583 3.54154H17.5833ZM12.3749 14.2665H8.62493C8.22493 14.2665 7.8916 13.9415 7.8916 13.5332C7.8916 13.1249 8.2166 12.7999 8.62493 12.7999H12.3749C12.7749 12.7999 13.1083 13.1249 13.1083 13.5332C13.1083 13.9415 12.7833 14.2665 12.3749 14.2665ZM17.3749 8.74987H3.62493V5.41654C3.62493 5.1832 3.80827 4.99987 4.0416 4.99987H5.8916V6.14154C5.8916 6.54154 6.2166 6.87487 6.62493 6.87487C7.03327 6.87487 7.35827 6.54987 7.35827 6.14154V4.99987H13.6666V6.14154C13.6666 6.54154 13.9916 6.87487 14.3999 6.87487C14.8083 6.87487 15.1333 6.54987 15.1333 6.14154V4.99987H16.9833C17.2166 4.99987 17.3999 5.1832 17.3999 5.41654V8.74987H17.3749Z"
        fill="#6B6B6B"
      />
    </g>
    <defs>
      <clipPath id="clip0_7994_61407">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
`;

export const CheckIcon = html`<svg
  width="100%"
  height="100%"
  viewBox="0 0 15 15"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="3.08716"
    y="7.07153"
    width="1.5"
    height="4"
    transform="rotate(-45 3.08716 7.07153)"
    fill="currentColor"
  />
  <rect
    x="5.91553"
    y="9.8999"
    width="8"
    height="1.5"
    transform="rotate(-45 5.91553 9.8999)"
    fill="currentColor"
  />
</svg>`;

export const HeartLineIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 44 44"
  fill="none"
>
  <path
    d="M30.6109 10.5417C33.3036 10.5417 35.5201 12.0267 36.5459 14.52C38.5426 19.3967 34.9339 24.8784 33.2487 27.06C28.1929 33.055 23.9248 35.7867 22.0198 36.8317C20.1147 35.805 15.8283 33.055 10.7908 27.06C9.10559 24.8784 5.51527 19.3967 7.49361 14.52C8.51942 12.0267 10.7359 10.5417 13.4286 10.5417C15.81 10.5417 17.8982 11.715 19.0156 13.6584L19.1622 13.8967C19.7666 14.905 20.8657 15.5284 22.0381 15.5284C23.2104 15.5284 24.3095 14.905 24.914 13.8967L25.0605 13.6584C26.1779 11.6967 28.2662 10.5417 30.6475 10.5417M30.6109 7.33337C27.3136 7.33337 24.0347 8.94671 22.2396 12.0634C22.2029 12.1184 22.1663 12.1917 22.1297 12.2467C22.1113 12.2834 22.0564 12.32 22.0014 12.32C21.9465 12.32 21.9098 12.3017 21.8732 12.2467C21.8366 12.1917 21.7999 12.1184 21.7633 12.0634C19.9865 8.94671 16.6892 7.33337 13.392 7.33337C9.76504 7.33337 6.13808 9.27671 4.48947 13.31C2.27299 18.7367 4.87414 24.7317 8.26297 29.0767C15.0772 37.18 20.6276 39.8017 21.7816 40.2967C21.8549 40.3334 21.9282 40.3334 22.0014 40.3334C22.0747 40.3334 22.148 40.3334 22.2212 40.2967C23.3753 39.82 28.9073 37.1984 35.7399 29.0767C39.1104 24.7317 41.7299 18.7367 39.5134 13.31C37.8648 9.27671 34.2378 7.33337 30.6109 7.33337Z"
    fill="currentColor"
  />
</svg>`;
